<template>
<span class="form-text text-muted">
    <slot></slot>
</span>
</template>

<script>
export default {
    
}
</script>